import * as React from "react";
import { CircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const faqData = [{
  question: "What personal data do we collect and why?",
  answer: "We collect information you provide directly to us, such as your name, email address, and contact details when you use our services. This data is used to personalize your experience, process transactions, and improve our overall service delivery."
}, {
  question: "How do we protect and store your information?",
  answer: "Your data is stored on secure servers with industry-standard encryption. We implement a variety of security measures to maintain the safety of your personal information when you enter, submit, or access your data."
}, {
  question: "Do we share your information with third parties?",
  answer: "We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties except for trusted third parties who assist us in operating our website, so long as those parties agree to keep this information confidential."
}, {
  question: "What are your rights regarding your personal data?",
  answer: "You have the right to access, correct, or delete your personal data at any time. You can also object to the processing of your data or request data portability by contacting our privacy team through the provided channels."
}, {
  question: "How can you contact us regarding privacy concerns?",
  answer: "If there are any questions regarding this privacy policy, you may contact us using the information on our contact page. We are committed to resolving any complaints about our collection or use of your personal information."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="261058" id="full-privacy-policy" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12 flex flex-col items-center">
          <Badge variant="secondary" className="mb-4 bg-primary/10 text-primary hover:bg-primary/20 border-none rounded-md">
            <CircleQuestionMark className="w-4 h-4 mr-1 text-primary" />
            Legal Transparency
          </Badge>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground font-default mb-4 tracking-tight">
            Privacy Policy & Data Protection
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-sans">
            We value your trust. This policy outlines how we handle your personal information with the highest standards of security and transparency.
          </p>
        </div>

        <Card className="shadow-lg border-border bg-card rounded-lg">
          <CardContent className="p-6 md:p-8">
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border last:border-0">
                  <AccordionTrigger className="text-foreground font-default font-semibold text-left text-base md:text-xl hover:text-primary transition-colors py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed text-base font-sans pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </CardContent>
        </Card>
      </div>
    </section>;
}